
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/useful-expressions",
      function () {
        return require("private-next-pages/courses/useful-expressions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/useful-expressions"])
      });
    }
  